/* eslint-disable no-restricted-globals */
import React from "react"
import { Select, Input, TextArea } from "semantic-ui-react"

const options = [{ key: 0, value: "PKCS12", text: "PKCS12" }]

const languages = [
  { key: 0, value: "kk", text: "kk" },
  { key: 0, value: "ru", text: "ru" },
  { key: 0, value: "en", text: "en" },
]

const labelStyle = { width: "20vw", display: "inline-block" }
const inputStyle = { width: "70vw", display: "inline-block" }
const divStyle = { marginBottom: 10 }

const webSocket = new WebSocket("wss://127.0.0.1:13579/")
let callback = null

export default class ECPSignatureComponent extends React.Component {
  state = {
    storageSelect: options[0].value,
    options: options,
    alias: "Alias",
    keyId: "keyId",
    algorithm: "algorithm",
    subjectCN: "subjectCN",
    subjectDN: "subjectDN",
    issuerCN: "issuerCN",
    issuerDN: "issuerDN",
    serialNumber: "serialNumber",
    NotBefore: "NotBefore",
    NotAfter: "NotAfter",
    authorityKeyIdentifier: "authorityKeyIdentifier",
    pem: "",
    xmlToSign: "",
    xmlToSign1: "",
    xmlToSign2: "",
    signedXml: "",
    signedXml1: "",
    signedXml2: "",
    filePath: "",
    createdCMS: "",
    base64ToSign: "",
    createdCMSforBase64: "",
    createdCMSforBase64Hash: "",
    CMSForTS: "",
    localeSelect: languages[1].value,
    flag: false,
    flagForBase64: false,
  }

  functions = () => {
    return {
      getActiveTokensBack: this.getActiveTokensBack,
      getKeyInfoBack: this.getKeyInfoBack,
      signXmlBack: this.signXmlBack,
      signXmlsBack: this.signXmlsBack,
      showFileChooserBack: this.showFileChooserBack,
      createCAdESFromFileBack: this.createCAdESFromFileBack,
      createCAdESFromBase64Back: this.createCAdESFromBase64Back,
      createCAdESFromBase64HashBack: this.createCAdESFromBase64HashBack,
      applyCAdESTBack: this.applyCAdESTBack,
    }
  }

  componentDidMount() {
    const openDialog = this.openDialog
    const functions = this.functions()
    webSocket.onopen = (event) => {
      //
    }

    webSocket.onclose = (event) => {
      if (event.wasClean) {
        console.log("connection has been closed")
      } else {
        console.log("Connection error")
        openDialog()
      }
      console.log("Code: " + event.code + " Reason: " + event.reason)
    }

    webSocket.onmessage = (event) => {
      let result = JSON.parse(event.data)
      console.log(result)

      if (result != null) {
        let rw = {
          code: result["code"],
          message: result["message"],
          responseObject: result["responseObject"],
          getResult: () => {
            return this.result
          },
          getMessage: () => {
            return this.message
          },
          getResponseObject: () => {
            return this.responseObject
          },
          getCode: () => {
            return this.code
          },
        }
        if (callback != null) {
          functions[callback](rw)
        }
      }
      // console.log(event);
    }
  }

  openDialog = () => {
    if (
      confirm(
        "Ошибка при подключении к NCALayer. Запустите NCALayer и нажмите ОК",
      ) === true
    ) {
      location.reload()
    }
  }

  blockScreen = () => {
    /* $.blockUI({
      message:
        '<img src="js/loading.gif" /><br/>Подождите, выполняется операция в NCALayer...',
      css: {
        border: "none",
        padding: "15px",
        backgroundColor: "#000",
        "-webkit-border-radius": "10px",
        "-moz-border-radius": "10px",
        opacity: 0.5,
        color: "#fff",
      },
    }) */
  }

  getActiveTokens = (callBack) => {
    let getActiveTokens = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "getActiveTokens",
    }
    callback = callBack
    webSocket.send(JSON.stringify(getActiveTokens))
  }

  getActiveTokensCall = () => {
    this.blockScreen()
    this.getActiveTokens("getActiveTokensBack")
  }

  unblockScreen = () => {
    // $.unblockUI()
  }

  getActiveTokensBack = (result) => {
    this.unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let listOfTokens = result["responseObject"]
      const temp = []
      temp.push({ text: "PKCS12", value: "PKCS12" })
      for (let i = 0; i < listOfTokens.length; i++) {
        temp.push({ text: listOfTokens[i], value: listOfTokens[i] })
      }
      this.setState({ storageSelect: temp })
    }
  }

  getKeyInfoCall = () => {
    this.blockScreen()
    let selectedStorage = this.state.storageSelect
    this.getKeyInfo(selectedStorage, "getKeyInfoBack")
  }

  getKeyInfoBack = (result) => {
    this.unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      console.log(res)
      let alias = res["alias"]
      let keyId = res["keyId"]
      let algorithm = res["algorithm"]
      let subjectCn = res["subjectCn"]
      let subjectDn = res["subjectDn"]
      let issuerCn = res["issuerCn"]
      let issuerDn = res["issuerDn"]
      let serialNumber = res["serialNumber"]
      let dateString = res["certNotAfter"]
      let date = new Date(Number(dateString))
      let dateString1 = res["certNotBefore"]
      let date1 = new Date(Number(dateString1))
      let authorityKeyIdentifier = res["authorityKeyIdentifier"]
      let pem = res["pem"]

      this.setState({
        alias: alias,
        keyId: keyId,
        algorithm: algorithm,
        subjectCN: subjectCn,
        subjectDN: subjectDn,
        issuerCN: issuerCn,
        issuerDN: issuerDn,
        serialNumber: serialNumber,
        NotBefore: date1.toLocaleString(),
        NotAfter: date.toLocaleString(),
        authorityKeyIdentifier: authorityKeyIdentifier,
        pem: pem,
      })
    }
  }

  getKeyInfo = (storageName, callBack) => {
    let getKeyInfo = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "getKeyInfo",
      args: [storageName],
    }
    callback = callBack
    webSocket.send(JSON.stringify(getKeyInfo))
  }

  signXmlCall = () => {
    let xmlToSign = this.state.xmlToSign
    let selectedStorage = this.state.storageSelect
    this.blockScreen()
    this.signXml(selectedStorage, "SIGNATURE", xmlToSign, "signXmlBack")
  }

  signXmlBack = (result) => {
    this.unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      console.log(res)
      this.setState({ signedXml: res })
    }
  }

  signXml = (storageName, keyType, xmlToSign, callBack) => {
    let signXml = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "signXml",
      args: [storageName, keyType, xmlToSign, "", ""],
    }
    callback = callBack
    webSocket.send(JSON.stringify(signXml))
  }

  signXmlsCall = () => {
    let xmlToSign1 = this.state.xmlToSign1
    let xmlToSign2 = this.state.xmlToSign2
    // eslint-disable-next-line no-array-constructor
    let xmlsToSign = new Array(xmlToSign1, xmlToSign2)
    let selectedStorage = this.state.storageSelect
    this.blockScreen()
    this.signXmls(selectedStorage, "SIGNATURE", xmlsToSign, "signXmlsBack")
  }

  signXmlsBack = (result) => {
    this.unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      this.setState({ signedXml1: res[0], signedXml2: res[1] })
    }
  }

  signXmls = (storageName, keyType, xmlsToSign, callBack) => {
    let signXmls = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "signXmls",
      args: [storageName, keyType, xmlsToSign, "", ""],
    }
    callback = callBack
    webSocket.send(JSON.stringify(signXmls))
  }

  showFileChooserCall = () => {
    this.blockScreen()
    this.showFileChooser("ALL", "", "showFileChooserBack")
  }

  showFileChooserBack = (result) => {
    this.unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      this.setState({ filePath: res })
    }
  }

  showFileChooser = (fileExtension, currentDirectory, callBack) => {
    let showFileChooser = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "showFileChooser",
      args: [fileExtension, currentDirectory],
    }
    callback = callBack
    webSocket.send(JSON.stringify(showFileChooser))
  }

  createCAdESFromFileCall = () => {
    let selectedStorage = this.state.storageSelect
    let flag = this.state.flag
    let filePath = this.state.filePath
    if (filePath !== null && filePath !== "") {
      this.blockScreen()
      this.createCAdESFromFile(
        selectedStorage,
        "SIGNATURE",
        filePath,
        flag,
        "createCAdESFromFileBack",
      )
    } else {
      alert("Не выбран файл для подписи!")
    }
  }

  createCAdESFromFile = (storageName, keyType, filePath, flag, callBack) => {
    let createCAdESFromFile = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "createCAdESFromFile",
      args: [storageName, keyType, filePath, flag],
    }
    callback = callBack
    webSocket.send(JSON.stringify(createCAdESFromFile))
  }

  createCAdESFromFileBack = (result) => {
    this.unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      this.setState({ createdCMS: res })
    }
  }

  createCAdESFromBase64Call = () => {
    let selectedStorage = this.state.storageSelect
    let flag = this.state.flagForBase64
    let base64ToSign = this.state.base64ToSign
    if (base64ToSign !== null && base64ToSign !== "") {
      // $.blockUI()
      this.createCAdESFromBase64(
        selectedStorage,
        "SIGNATURE",
        base64ToSign,
        flag,
        "createCAdESFromBase64Back",
      )
    } else {
      alert("Нет данных для подписи!")
    }
  }

  createCAdESFromBase64Back = (result) => {
    // $.unblockUI()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      console.log(res)
      this.setState({ createdCMSforBase64: res })
    }
  }

  createCAdESFromBase64 = (
    storageName,
    keyType,
    base64ToSign,
    flag,
    callBack,
  ) => {
    let createCAdESFromBase64 = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "createCAdESFromBase64",
      args: [storageName, keyType, base64ToSign, flag],
    }
    callback = callBack
    webSocket.send(JSON.stringify(createCAdESFromBase64))
  }

  createCAdESFromBase64HashCall = () => {
    let selectedStorage = this.state.storageSelect
    let base64ToSign = this.state.base64ToSign
    if (base64ToSign !== null && base64ToSign !== "") {
      // $.blockUI()
      this.createCAdESFromBase64Hash(
        selectedStorage,
        "SIGNATURE",
        base64ToSign,
        "createCAdESFromBase64HashBack",
      )
    } else {
      alert("Нет данных для подписи!")
    }
  }

  createCAdESFromBase64HashBack = (result) => {
    // $.unblockUI()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      this.setState({ createdCMSforBase64Hash: res })
    }
  }

  createCAdESFromBase64Hash = (
    storageName,
    keyType,
    base64ToSign,
    callBack,
  ) => {
    let createCAdESFromBase64Hash = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "createCAdESFromBase64Hash",
      args: [storageName, keyType, base64ToSign],
    }
    callback = callBack
    webSocket.send(JSON.stringify(createCAdESFromBase64Hash))
  }

  applyCAdESTCall = () => {
    let selectedStorage = this.state.storageSelect
    let cmsForTS = this.state.CMSForTS
    if (cmsForTS !== null && cmsForTS !== "") {
      // $.blockUI()
      this.applyCAdEST(
        selectedStorage,
        "SIGNATURE",
        cmsForTS,
        "applyCAdESTBack",
      )
    } else {
      alert("Нет данных для подписи!")
    }
  }

  applyCAdESTBack = (result) => {
    // $.unblockUI()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      this.setState({ createdCMSWithAppliedTS: res })
    }
  }

  applyCAdEST = (storageName, keyType, cmsForTS, callBack) => {
    let applyCAdEST = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "applyCAdEST",
      args: [storageName, keyType, cmsForTS],
    }
    callback = callBack
    webSocket.send(JSON.stringify(applyCAdEST))
  }

  changeLocaleCall = () => {
    let selectedLocale = this.state.localeSelect
    this.changeLocale(selectedLocale)
  }

  changeLocale = (language) => {
    let changeLocale = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "changeLocale",
      args: [language],
    }
    callback = null
    webSocket.send(JSON.stringify(changeLocale))
  }

  render() {
    return (
      <>
        <div>
          <div>
            <h1 style={{ textAlign: "center" }}>
              Примеры использования методов NCALayer
            </h1>
            Выберите необходимый тип носителя
            <Input
              value="Добавить доступные токены"
              onClick={() => this.getActiveTokensCall()}
              type="button"
            />
            <p></p>
            <Select
              options={this.state.options}
              value={this.state.storageSelect}
              onChange={(e, d) => {
                this.setState({ storageSelect: d.value })
              }}
              fluid
            />
            <h2>1. Данные ключа</h2>
            <Input
              value="Получить данные ключа"
              onClick={() => this.getKeyInfoCall()}
              type="button"
            />
            <div style={divStyle}>
              <label style={labelStyle}>Алиас ключа:</label>
              <div style={inputStyle}>
                <Input type="text" value={this.state.alias} disabled fluid />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>Идентификатор ключа:</label>
              <div style={inputStyle}>
                <Input
                  class="form-control"
                  type="text"
                  value={this.state.keyId}
                  fluid
                />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>Алгоритм ключа:</label>
              <div style={inputStyle}>
                <Input
                  type="text"
                  value={this.state.algorithm}
                  fluid
                  disabled
                />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>Общепринятое имя субъекта:</label>
              <div style={inputStyle}>
                <Input
                  type="text"
                  value={this.state.subjectCN}
                  fluid
                  disabled
                />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>Уникальное имя субъекта:</label>
              <div style={inputStyle}>
                <Input
                  type="text"
                  value={this.state.subjectDN}
                  fluid
                  disabled
                />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>Общепринятое имя издателя:</label>
              <div style={inputStyle}>
                <Input type="text" value={this.state.issuerCN} fluid disabled />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>Уникальное имя издателя:</label>
              <div style={inputStyle}>
                <Input type="text" value={this.state.issuerDN} fluid disabled />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>Серийный номер сертификата:</label>
              <div style={inputStyle}>
                <Input
                  type="text"
                  value={this.state.serialNumber}
                  fluid
                  disabled
                />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>
                Дата начала действия сертификата:
              </label>
              <div style={inputStyle}>
                <Input
                  type="text"
                  value={this.state.NotBefore}
                  fluid
                  disabled
                />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>
                Дата окончания действия сертификата:
              </label>
              <div style={inputStyle}>
                <Input type="text" value={this.state.NotAfter} disabled fluid />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>Идентификатор ключа УЦ:</label>
              <div style={inputStyle}>
                <Input
                  type="text"
                  value={this.state.authorityKeyIdentifier}
                  disabled
                  fluid
                />
              </div>
            </div>
            <div style={divStyle}>
              <label style={labelStyle}>Сертификат в формате PEM:</label>
              <div style={inputStyle}>
                <TextArea
                  value={this.state.pem}
                  rows="3"
                  readOnly
                  style={{ width: "70vw" }}
                />
              </div>
            </div>
          </div>
          <div style={divStyle}>
            <h2>2. Подпись XML</h2>
            <div style={{ display: "flex" }}>
              <div>
                <TextArea
                  value={this.state.xmlToSign}
                  rows="3"
                  placeholder={"Введите XML"}
                  style={{ width: "80vw" }}
                  onChange={(e, d) => {
                    this.setState({ xmlToSign: d.value })
                  }}
                />
              </div>
              <div style={{ width: 20 }}></div>
              <div>
                <Input
                  value="Подписать XML"
                  onClick={() => this.signXmlCall()}
                  type="button"
                />
              </div>
            </div>
            <TextArea
              value={this.state.signedXml}
              rows="6"
              readOnly
              fluid
              placeholder={"Подписанный XML"}
              style={{ width: "100%" }}
            />
          </div>
          <div>
            <h2>3. Подпись массива XML</h2>
            <div>
              <div>
                <div>
                  <div style={{ margin: 10 }}>
                    <label>XML #1:</label>
                  </div>
                  <TextArea
                    value={this.state.xmlToSign1}
                    rows="3"
                    placeholder={"Введите XML"}
                    style={{ width: "60%" }}
                    onChange={(e, d) => {
                      this.setState({ xmlToSign1: d.value })
                    }}
                  />
                </div>
                <div>
                  <div style={{ margin: 10 }}>
                    <label>XML #2:</label>
                  </div>
                  <TextArea
                    value={this.state.xmlToSign2}
                    rows="3"
                    placeholder={"Введите XML"}
                    style={{ width: "60%" }}
                    onChange={(e, d) => {
                      this.setState({ xmlToSign2: d.value })
                    }}
                  />
                </div>
                Примечание: Количество XML может быть больше, так как они
                передаются в виде массива
              </div>
            </div>
            <div>
              <Input
                value="Подписать XML"
                onClick={() => this.signXmlsCall()}
                type="button"
                style={{ width: "50%" }}
              />
            </div>
            <div style={{ margin: 10 }}>
              <TextArea
                value={this.state.signedXml1}
                rows="6"
                readOnly
                placeholder={"Подписанный XML"}
                style={{ width: "60%" }}
              />
            </div>
            <div style={{ margin: 10 }}>
              <TextArea
                value={this.state.signedXml2}
                rows="6"
                placeholder={"Подписанный XML"}
                style={{ width: "60%" }}
                readOnly
              />
            </div>
          </div>
          <div>
            <h2>4. Подпись файла в формате CMS</h2>
            <div>
              <div style={labelStyle}>
                <Input
                  value="Выбрать файл для подписи"
                  onClick={() => this.showFileChooserCall()}
                  type="button"
                />
              </div>
              <div style={inputStyle}>
                <Input type="text" value={this.state.filePath} disabled fluid />
              </div>
            </div>
            <div>
              <Input
                type="checkbox"
                checked={this.state.flag}
                onChange={(e, d) => {
                  this.setState({ flag: !d.checked })
                }}
              />{" "}
              Включить данные в подпись
            </div>
            <Input
              value="Подписать"
              onClick={() => this.createCAdESFromFileCall()}
              type="button"
              style={{ width: "50%" }}
            />
            <div style={{ marginTop: 10 }}>
              <TextArea
                value={this.state.createdCMS}
                rows="6"
                readOnly
                placeholder={"Подпись в формате CMS"}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div>
            <h2>5. Подпись Base64 данных в формате CMS</h2>
            <div>
              <div>
                <TextArea
                  value={this.state.base64ToSign}
                  rows="3"
                  placeholder={"Введите текст в формате Base64"}
                  style={{ width: "60vw" }}
                  onChange={(e, d) => {
                    this.setState({ base64ToSign: d.value })
                  }}
                />
              </div>
            </div>
            <div>
              <Input
                type="checkbox"
                checked={this.state.flagForBase64}
                onChange={(e, d) => {
                  this.setState({ flagForBase64: !d.checked })
                }}
              />{" "}
              Включить данные в подпись
            </div>
            <div style={{ marginTop: 10 }}>
              <Input
                value="Подписать"
                onClick={() => this.createCAdESFromBase64Call()}
                type="button"
                style={{ width: "50%" }}
              />
            </div>
            <div style={{ marginTop: 10 }}>
              <TextArea
                value={this.state.createdCMSforBase64}
                rows="6"
                readOnly
                placeholder={"Подпись в формате CMS"}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div>
            <h2>6. Подпись хэша данных Base64 в формате CMS</h2>
            <div>
              <div>
                <TextArea
                  id="base64HashToSign"
                  rows="3"
                  placeholder={"Введите хэш данных в формате Base64"}
                  style={{ width: "60vw" }}
                />
              </div>
            </div>
            <div>
              <Input
                value="Подписать"
                onClick={() => this.createCAdESFromBase64HashCall()}
                type="button"
                style={{ width: "50%" }}
              />
            </div>
            <div style={{ marginTop: 10 }}>
              <TextArea
                value={this.state.createdCMSforBase64Hash}
                rows="6"
                readOnly
                placeholder={"Подпись в формате CMS"}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div>
            <h2>7. Приложить метку времени к подписи CMS</h2>
            <div>
              <div>
                <TextArea
                  value={this.state.CMSForTS}
                  rows="3"
                  placeholder={"Введите CMS подпись в формате Base64"}
                  style={{ width: "60vw" }}
                  onChange={(e, d) => {
                    this.setState({ CMSForTS: d.value })
                  }}
                />
              </div>
            </div>
            <div>
              <Input
                value="Приложить метку времени"
                onClick={() => this.applyCAdESTCall()}
                type="button"
                style={{ width: "50%" }}
              />
            </div>
            <div style={{ marginTop: 10 }}>
              <TextArea
                value={this.state.createdCMSWithAppliedTS}
                rows="6"
                readOnly
                placeholder={"Подпись в формате CMS"}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div>
            Смена языка{" "}
            <Select
              options={languages}
              value={languages[1].value}
              id={this.state.localeSelect}
              onChange={(e, d) => {
                this.setState({ localeSelect: d.value })
              }}
            />
            <br />
            <br />
            <Input
              value="Сменить язык"
              onClick={() => this.changeLocaleCall()}
              type="button"
            />
          </div>
        </div>
      </>
    )
  }
}

// Form TextArea
// Select locale
